export default "__VITE_ASSET__DyyEwe3K__"